import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Switch14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M10.5304 4.46966L7.00006 0.939331L3.46973 4.46966L4.53039 5.53032L7.00006 3.06065L9.46973 5.53032L10.5304 4.46966Z'
      fill='currentColor'
    />
    <path
      d='M4.53039 8.46967L3.46973 9.53033L7.00006 13.0607L10.5304 9.53033L9.46973 8.46967L7.00006 10.9393L4.53039 8.46967Z'
      fill='currentColor'
    />
  </Svg>
);

Switch14.displayName = 'Switch14';
export default Switch14;
